import React from 'react';

import Button from '@components/_shared/button';

import styles from './styles.module.scss';

interface OverlayGalleryButtonsProps {
  scrollToVideoTour: () => void;
  onFloorplanClick: () => void;
  videoTourUrl?: string;
  floorPlan?: string;
}

export function OverlayGalleryButtons(props: OverlayGalleryButtonsProps) {
  const { scrollToVideoTour, onFloorplanClick, videoTourUrl, floorPlan } =
    props;

  return (
    <div className={styles.overlayButtons}>
      {videoTourUrl && (
        <Button
          containerStyle={styles.tourButton}
          onClick={scrollToVideoTour}
          variant="darkTanContained"
        >
          {videoTourUrl.includes('my.matterport.com') ? (
            <div className={styles.buttonContent}>
              <svg
                width="21"
                height="40"
                viewBox="0 0 21 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.3262 18.0909L20.2364 14.4742M10.3262 18.0909L0.763672 14.4742M10.3262 18.0909V29.5455M20.2364 14.4742L10.7645 10.6323C10.4838 10.5185 10.1694 10.5205 9.8901 10.6379L0.763672 14.4742M20.2364 14.4742V25.1079C20.2364 25.5883 19.9366 26.0176 19.4857 26.1832L10.3262 29.5455M0.763672 14.4742V25.1178C0.763672 25.5933 1.05742 26.0193 1.50184 26.1884L10.3262 29.5455"
                  stroke="white"
                  strokeWidth="1.14545"
                  strokeLinejoin="round"
                />
              </svg>
              3D Tour
            </div>
          ) : (
            <div className={styles.buttonContent}>
              <svg
                width="14"
                height="16"
                viewBox="0 0 14 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.40186 14.7983C1.16853 14.933 0.87686 14.7646 0.87686 14.4952L0.876859 1.50481C0.876859 1.23538 1.16853 1.06699 1.40186 1.2017L12.6519 7.69689C12.8852 7.83161 12.8852 8.16839 12.6519 8.30311L1.40186 14.7983Z"
                  stroke="white"
                  strokeWidth="1.3"
                  strokeLinejoin="round"
                />
              </svg>
              Video Tour
            </div>
          )}
        </Button>
      )}

      {floorPlan && (
        <Button
          containerStyle={styles.floorplanButton}
          onClick={onFloorplanClick}
          variant="blueContained"
        >
          <div className={styles.buttonContent}>
            <svg
              width="18"
              height="40"
              viewBox="0 0 18 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.25427 21.1454V18.4728M7.25427 21.1454H10.3087M7.25427 21.1454H4.39077M7.25427 21.1454V23.818M7.25427 15.0366V13.1276C7.25427 12.495 6.74146 11.9822 6.10887 11.9822H1.90907C1.27648 11.9822 0.763672 12.495 0.763672 13.1276V26.6815C0.763672 27.3141 1.27649 27.8269 1.90907 27.8269H15.463C16.0956 27.8269 16.6084 27.3141 16.6084 26.6815V22.2908C16.6084 21.6582 16.0956 21.1454 15.463 21.1454H13.3631M7.25427 15.0366V18.4728M7.25427 15.0366H4.39077M7.25427 18.4728H4.39077M10.3087 21.1454H13.3631M10.3087 21.1454V23.818M13.3631 21.1454V23.818"
                stroke="black"
                strokeWidth="1.1454"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Floorplan
          </div>
        </Button>
      )}
    </div>
  );
}
